module.exports = __webpack_public_path__ + "static/the-black-swan-4a2e0ba0a73d8e764ec069d06f13e093.jpg";